import "./AgentSelectionComponent.scss";
import { useIsMobile } from "@/hooks/use-mobile";

export type AgentType = 'analyst' | 'pm';

interface AgentSelectionComponentProps {
    onAgentSelection: (agent: AgentType) => void;
}

const AgentSelectionComponent = ({ onAgentSelection }: AgentSelectionComponentProps) => {
    const isMobile = useIsMobile();

    return (
        <div className="agent-selection-container">
            <h3 className="agent-selection-title">
                Which agent would you like to work with?
            </h3>
            <p className="agent-selection-subtitle">
                Choose the specialist that best fits your project needs
            </p>
            <div className="agent-selection-grid">
                {/* Business Analyst */}
                <button
                    onClick={() => onAgentSelection('analyst')}
                    className="agent-selection-card"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="agent-selection-icon"
                    >
                        <line x1="12" x2="12" y1="20" y2="10" />
                        <line x1="18" x2="18" y1="20" y2="4" />
                        <line x1="6" x2="6" y1="20" y2="16" />
                    </svg>
                    <h4 className="agent-selection-card-title">Business Analyst</h4>
                    {!isMobile && (
                        <p className="agent-selection-card-description">
                            Business and data analysis expert to help understand requirements and analytics
                        </p>
                    )}
                    <div className="agent-selection-badge agent-selection-badge-analyst">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
                        </svg>
                        Data-driven insights
                    </div>
                </button>

                {/* Product Manager */}
                <button
                    onClick={() => onAgentSelection('pm')}
                    className="agent-selection-card agent-selection-card-recommended"
                >
                    <div className="recommended-tag">Recommended</div>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="agent-selection-icon"
                    >
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    <h4 className="agent-selection-card-title">Product Manager</h4>
                    {!isMobile && (
                        <p className="agent-selection-card-description">
                            Roadmap and requirement expert to guide product vision and feature planning
                        </p>
                    )}
                    <div className="agent-selection-badge agent-selection-badge-pm">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
                            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
                        </svg>
                        Strategic planning
                    </div>
                </button>
            </div>
        </div>
    );
};

export default AgentSelectionComponent;
